export const EXPENSES_IMAGE_CODE = 3;

export const START_DATE_FIELD = "startDate";
export const END_DATE_FIELD = "endDate";
export const MOMENT_DAY = "day";
export const OFFSET_FIELD = "offset";
